import ChooseGiftPage from "./RecipientPortal/ChooseGiftPage/ChooseGiftPage";
import AdminDashboardPage from "./AdminPortal/AdminDashboardPage/AdminDashboardPage";
import CouponsPage from "./AdminPortal/CouponsPage/CouponsPage";
import SubscriptionPage from "./AdminPortal/SubscriptionPage/SubscriptionPage";
import CartPage from "./AdminPortal/CartPage/CartPage";
import GiftsPage from "./AdminPortal/GiftsPage/GiftsPage";
import AllCategoryItemsPage from "./AdminPortal/AllCategoryItemsPage/AllCategoryItemsPage";
import AllSectionItemsPage from "./AdminPortal/AllSectionItemsPage/AllSectionItemsPage";
import ItemDetailPage from "./AdminPortal/ItemDetailPage/ItemDetailPage";
import RecipientsPage from "./AdminPortal/RecipientsPage/RecipientsPage";
import OrderHistoryPage from "./AdminPortal/OrderHistoryPage/OrderHistoryPage";
import BillingPage from "./AdminPortal/BillingPage/BillingPage";
import AddItem from "./AdminPortal/MarketplacePage/AddItem/AddItem";
import CategoriesPage from "./AdminPortal/MarketplacePage/Categories/CategoriesPage";
import AttributesPage from "./AdminPortal/MarketplacePage/Attributes/AttributesPage";
import AccountSettingsPage from "./AdminPortal/AccountSettingsPage/AccountSettingsPage";
import SendGiftsPage from "./AdminPortal/SendGiftsPage/SendGiftsPage";
import RecipientDashboardPage from "./RecipientPortal/DashboardPage/RecipientDashboardPage";
import MobileAppPage from "./MobileAppPage/MobileAppPage";
import GiftOrderDetailsPage from "./AdminPortal/GiftOrderDetailsPage/GiftOrderDetailsPage";
import MarketplaceOrderDetailsPage from "./AdminPortal/MarketplaceOrderDetailsPage/MarketplaceOrderDetailsPage";
import AdminPricingPage from "./AdminPortal/PricingPage/AdminPricingPage";
import BusinessOrderHistoryPage from "./AdminPortal/BusinessOrderHistoryPage/BusinessOrderHistoryPage";
import CreateEditCoupon from "./AdminPortal/CouponsPage/CreateEditCoupon/CreateEditCoupon";
import MarketplacePage from "./AdminPortal/MarketplacePage/MarketplacePage";
import FavoritePage from "./AdminPortal/MarketplacePage/FavoritePage";
import MarketplaceItemDetailPage from "./AdminPortal/MarketplacePage/MarketplaceItemDetailPage/MarketplaceItemDetailPage";
import SetUpNewPasswordPage from "./OnboardingPages/SetUpNewPasswordPage/SetUpNewPasswordPage";
import StepBilling from "./OnboardingPages/SignupPage/SignupSteps/StepBilling";
import SignupFinal from "./OnboardingPages/SignupPage/SignupSteps/CompletedSignup";
import DashboardPage from "./AdminPortal/DashboardPage/Dashboard";
import BankTransfersPage from "./AdminPortal/SubscriptionPage/BankTransfersPage";
import CheckoutFinalPage from "./AdminPortal/MarketplacePage/CheckoutFinalPage";
import DeliveryDetailsPage from "./AdminPortal/MarketplaceOrderDeliveryDetails/DeliveryDetailsPage";
import DeleteAccountPage from "./DeleteAccount/DeleteAccountPage";
import VerificationSuccessPage from "./OnboardingPages/VerificationSuccessPage/VerificationSuccessPage";
import WalletCheckoutPage from "./AdminPortal/WalletCheckoutPage/WalletCheckoutPage";
import WalletCheckoutFinalPage from "./AdminPortal/WalletCheckoutPage/WalletCheckoutFinalPage";
import BusinessSubscriptionsPage from "./AdminPortal/BusinessSubscriptionsPage/BusinessSubscriptionsPage";
import PricingPage from "./PricingPage/PricingPage";
import SearchPage from "./AdminPortal/SearchPage/SearchPage";
import CompanySubscriptionHistoryPage from "./AdminPortal/SubscriptionPage/CompanySubscriptionHistoryPage";
import PGMPages from "./PGMPages/PGMPages";
import GamePage from "./GamePage/GamePage";
import AboutUsPage from "./AboutUsPage/AboutUsPage";
import PrivacyPolicyPage from "./PrivacyPolicyPage/PrivacyPolicyPage";
import MobileAppItemDetailPage from "./MobileAppPage/MobileAppItemDetailPage";
import MobileAppCheckout from "./MobileAppPage/MobileAppCheckout";
import MobileAppCheckoutFinal from "./MobileAppPage/MobileAppCheckoutFinal";
import PackagingPage from "./PackagingPage/PackagingPage";
import OpsPage from "./OpsPage/OpsPage";
import OpsOrderDetailPage from "./OpsPage/OpsOrderDetailPage";
import OpsCreateOrder from "./OpsPage/OpsCreateOrder";
import LandingPage from "./LandingPage/LandingPage";

const Pages = {
  ChooseGiftPage,
  AdminDashboardPage,
  CouponsPage,
  SubscriptionPage,
  CartPage,
  GiftsPage,
  AllCategoryItemsPage,
  AllSectionItemsPage,
  ItemDetailPage,
  RecipientsPage,
  OrderHistoryPage,
  BillingPage,
  AddItem,
  CategoriesPage,
  AttributesPage,
  AccountSettingsPage,
  SendGiftsPage,
  RecipientDashboardPage,
  MobileAppPage,
  GiftOrderDetailsPage,
  MarketplaceOrderDetailsPage,
  AdminPricingPage,
  BusinessOrderHistoryPage,
  CreateEditCoupon,
  MarketplacePage,
  FavoritePage,
  MarketplaceItemDetailPage,
  SetUpNewPasswordPage,
  StepBilling,
  SignupFinal,
  DashboardPage,
  BankTransfersPage,
  CheckoutFinalPage,
  DeliveryDetailsPage,
  DeleteAccountPage,
  VerificationSuccessPage,
  WalletCheckoutPage,
  WalletCheckoutFinalPage,
  BusinessSubscriptionsPage,
  PricingPage,
  SearchPage,
  CompanySubscriptionHistoryPage,
  PGMPages,
  GamePage,
  AboutUsPage,
  PrivacyPolicyPage,
  MobileAppItemDetailPage,
  MobileAppCheckout,
  MobileAppCheckoutFinal,
  PackagingPage,
  OpsPage,
  OpsOrderDetailPage,
  OpsCreateOrder,
  LandingPage,
};

export default Pages;
